import {Component, OnInit} from '@angular/core';
import {
    fadeInLeftOnEnterAnimation,
    fadeInOnEnterAnimation,
    fadeOutOnLeaveAnimation,
    fadeOutRightOnLeaveAnimation
} from 'angular-animations';
import {DomSanitizer} from '@angular/platform-browser';
import {UserInfoModel} from '../../../services/models/user-info.model';
import {UserService} from '../../../services/user.service';
import {ActivatedRoute} from '@angular/router';
import {NavService} from '../../../services/nav.service';
import {JourneyService} from '../service/journey.service';
import {TasksModel} from '../../tasks/models/tasks.model';


@Component({
    selector: 'app-task-page',
    templateUrl: './task.page.html',
    styleUrls: ['./task.page.scss'],
    animations: [
        fadeInOnEnterAnimation({anchor: 'enter', duration: 500}),
        fadeOutOnLeaveAnimation({anchor: 'leave', duration: 500}),
        fadeOutRightOnLeaveAnimation({anchor: 'leaveList', duration: 300}),
        fadeInLeftOnEnterAnimation({anchor: 'enterList', duration: 300}),
    ]
})

export class TaskPage implements OnInit {

    task: TasksModel = null;
    task_id = null;

    userInfo: UserInfoModel = null;
    url = null;

    constructor(
        public sanitizer: DomSanitizer,
        public userService: UserService,
        private journeyService: JourneyService,
        private route: ActivatedRoute,
        private nav: NavService
    ) {}

    ngOnInit() {
        this.task_id = parseInt(this.route.snapshot.paramMap.get("task_id"), 10);

        if (!this.task_id) {
            this.nav.back();
        } else {
            this.userInfo = this.userService.getCurrentUserInfo(false);
            if (this.userInfo !== null) {
                this.initTaskData();
            } else {
                this.userService.getUserInfo()
                    .then((userInfo) => {
                        this.userInfo = userInfo;
                        this.initTaskData();
                    });
            }
        }
    }

    initTaskData() {
        this.journeyService.getMyTask(this.task_id)
            .then((task) => {
                if (task !== null) {
                    this.task = task;

                    if (task.url.indexOf('https://forms.office.com') >= 0 && task.url.indexOf('embed=true') === -1) {
                        this.url = task.url + (task.url.indexOf('?') >= 0 ? '&embed=true' : '?embed=true');
                    } else {
                        this.url = task.url;
                    }
                } else {
                    this.nav.back();
                }
            })

    }
}
